import { render, staticRenderFns } from "./CottonData.vue?vue&type=template&id=626ea9e1&scoped=true&"
import script from "./CottonData.vue?vue&type=script&lang=js&"
export * from "./CottonData.vue?vue&type=script&lang=js&"
import style0 from "./CottonData.vue?vue&type=style&index=0&id=626ea9e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626ea9e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
